<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal'
import { VueQueryDevtools } from '@tanstack/vue-query-devtools'
import { usePostHogProvider } from '@/composables/usePosthog'
import { useRoute } from 'vue-router'
import { computed, onBeforeUnmount, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useTeacherAccountCleanup } from '@/queries/teachers/teachers.query'
import { useStoryAccountCleanup } from '@/queries/stories'
import { useAchievementAccountCleanup } from '@/queries/user/user.query'
import { useNotificationSync } from '@/composables/useNotificationSync'
import { onMessage } from 'firebase/messaging'
import { messaging } from './services/firebase'
import Toast from 'primevue/toast'
import { useToast } from 'primevue/usetoast'

const toast = useToast()
const teacherAuth = useAuthStore()
useAchievementAccountCleanup(computed(() => (teacherAuth.isAuthenticated ? teacherAuth.user?.id || '' : '')))
useStoryAccountCleanup(
  computed(() => (teacherAuth.isAuthenticated ? teacherAuth.user?.id || '' : ''))
)
useTeacherAccountCleanup(
  computed(() => (teacherAuth.isAuthenticated ? teacherAuth.user?.id || '' : ''))
)
const notifications = useNotificationSync()
let stopMessages: (() => void) | undefined

const route = useRoute()

usePostHogProvider(import.meta.env.VITE_POSTHOG_KEY, {
  api_host: import.meta.env.VITE_POSTHOG_HOST,
  person_profiles: 'identified_only'
})

onMounted(() => {
  stopMessages = onMessage(messaging, (payload) => {
    void notifications.refreshUnreadCount()
    toast.add({
      summary: payload.notification?.title,
      detail: payload.notification?.body,
      severity: 'info',
      life: 5000
    })
  })
})
onBeforeUnmount(() => stopMessages?.())
</script>

<template>
  <router-view v-slot="{ Component, route }">
    <component :is="Component" :key="route.matched[0]?.path === '/auth' ? '/auth' : route.path" />
  </router-view>
  <VueQueryDevtools :initialIsOpen="false" />
  <ModalsContainer />
</template>
